import { all, fork, put, takeEvery,takeLatest, call } from 'redux-saga/effects';
import { InventoryActionTypes } from './constants';

import {Inventory,updateInventory,ProfitLoss } from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */


function* inventoryDataGetFunction(data) {
    try {
        yield put({
            type: InventoryActionTypes.INVENTORY_DATA_LOADING,
            payload: {},
        });
        const response = yield call(Inventory,data);
        if (response?.status===200) {
            yield put({
                type: InventoryActionTypes.INVENTORY_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: InventoryActionTypes.INVENTORY_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: InventoryActionTypes.INVENTORY_DATA_ERROR,
            payload: error,
        });
    }
}

function* updateInventoryFunction(payload) {
    try {
        yield put({
            type: InventoryActionTypes.UPDATE_INVENTORY_DATA_LOADING,
        });

        const response = yield call(updateInventory, payload);

        if (response && response.data && response.data.status === 200) {
            yield put({
                type: InventoryActionTypes.UPDATE_INVENTORY_DATA_SUCCESS,
                payload: response.data,
            });
            yield put({
                type: InventoryActionTypes.UPDATE_INVENTORY_DATA_RESET,
            });
        } else {
            yield put({
                type: InventoryActionTypes.UPDATE_INVENTORY_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: InventoryActionTypes.UPDATE_INVENTORY_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* profitLossDataGetFunction(data) {
    try {
        yield put({
            type: InventoryActionTypes.PROFIT_LOSS_DATA_LOADING,
            payload: {},
        });
        const response = yield call(ProfitLoss,data);
        if (response?.status===200) {
            yield put({
                type: InventoryActionTypes.PROFIT_LOSS_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: InventoryActionTypes.PROFIT_LOSS_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: InventoryActionTypes.PROFIT_LOSS_DATA_ERROR,
            payload: error,
        });
    }
}


export function* watchInventoryData() {
    yield takeLatest(InventoryActionTypes.INVENTORY_DATA_FIRST, inventoryDataGetFunction);
    yield takeLatest(InventoryActionTypes.UPDATE_INVENTORY_DATA_FIRST, updateInventoryFunction);
    yield takeLatest(InventoryActionTypes.PROFIT_LOSS_DATA_FIRST, profitLossDataGetFunction);
}
function* inventorySaga() {
    yield all([
        fork(watchInventoryData),
    ]);
}
export default inventorySaga;
